export default __webpack_public_path__ + "static/media/apropos.3167cf52.jpg";